import React, { useContext } from "react";
import { SurveyContext } from "../../store/survey-context";
import "./loader.scss";

export default function Loader(props) {
  const context = useContext(SurveyContext);
  const { setLoader } = context;

  if (props.time) {
    document.getElementById("cta-back-dashboard").hidden = true;
    setTimeout(() => {
      setLoader(false);
      document.getElementById("cta-back-dashboard").hidden = false;
    }, props.time);
  }

  const text = props.text === "app.loading" ? "Loading" : props.text;

  return (
    <>
      <div className="loader mv-xl">
        <div className="loader-animation fade-in"></div>
        <div className="loading-text">
          <p className="loading">
            {text} {props.time}
          </p>
        </div>
      </div>
    </>
  );
}
